<template>
    <AppLayoutBase>
        <template slot="main">
            <AuthForgotPasswordContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>